import { render, staticRenderFns } from "./MaxBookingCount.vue?vue&type=template&id=48f1728a&scoped=true"
import script from "./MaxBookingCount.vue?vue&type=script&lang=js"
export * from "./MaxBookingCount.vue?vue&type=script&lang=js"
import style0 from "./MaxBookingCount.vue?vue&type=style&index=0&id=48f1728a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f1728a",
  null
  
)

export default component.exports